import { Badge, type BadgeTone } from './Badge';

export type TicketStatus = 'Açık' | 'İşlemde' | 'Beklemede' | 'Çözüldü' | 'Kapalı';

export interface StatusPillProps {
  status: TicketStatus | string;
}

const STATUS_MAP: Record<string, { tone: BadgeTone; dot: boolean }> = {
  'Açık':      { tone: 'brand',   dot: true  },
  'İşlemde':   { tone: 'warn',    dot: true  },
  'Beklemede': { tone: 'slate',   dot: true  },
  'Çözüldü':   { tone: 'ok',      dot: true  },
  'Kapalı':    { tone: 'neutral', dot: false },
};

export function StatusPill({ status }: StatusPillProps) {
  const { tone, dot } = STATUS_MAP[status] ?? { tone: 'neutral' as BadgeTone, dot: false };
  return <Badge tone={tone} dot={dot}>{status}</Badge>;
}
